import { io, Socket } from "socket.io-client";
import { API_BASE } from "../config/api-url";

let notificationsSocket: Socket | null = null;

export function getNotificationsSocket(): Socket {
	if (!notificationsSocket) {
		notificationsSocket = io(`${API_BASE}/notifications`, {
			autoConnect: false,
			transports: ["websocket"],
			withCredentials: true,
		});
	}
	return notificationsSocket;
}

export function connectNotificationsSocket(): Socket {
	const socket = getNotificationsSocket();
	if (!socket.connected) socket.connect();
	return socket;
}

export function disconnectNotificationsSocket(): void {
	notificationsSocket?.disconnect();
}
